import { atom } from 'jotai';

import { updateV2SocketData } from '../v2-helper';
import { createTableAccumulatorBunja } from './table-accumulator';

export type Wallets = Record<string, Wallet> | null;

export interface Wallet {
  walletBalanceInUsdt: string;
  walletBalanceExclWithdrawalPending: string; // walletBalanceInUsdt - pending withdrawals
  walletBalanceExclWithdrawalPendingInUsdt: string;
  walletBalanceTransferable: string;
  walletBalanceTransferableInUsdt: string;
  walletBalanceExclWithdrawalPendingForSubAccounts: string;
  walletBalanceWithdrawable: string;
  walletBalanceWithdrawableInUsdt: string;
  walletBalanceExclLocked: string;
  walletBalanceExclLockedInUsdt: string;
  walletBalanceStaked: string;
  walletBalanceStakedInUsdt: string;
  walletBalanceExclLockedBySpotTrade: string;
  walletBalanceDefiYieldPendingInUsdt: string;
  pnlPct: string | null;
  pnl: string | null;
  avgEntryPrice: string | null;
  walletBalanceLocked: string | null;
}

export const walletsAtom = atom<Wallets>(null);

export const subscribeWalletsBunja = createTableAccumulatorBunja(
  'private/wallets',
  (store) => (wsData) => store.set(walletsAtom, (prev) => updateV2SocketData(prev || {}, wsData)),
);
subscribeWalletsBunja.debugLabel = 'subscribeWalletsBunja';
